export default __webpack_public_path__ + "static/media/sy.2da8e713.svg";